import { AddEdit } from '../../../../interfaces/property.interface';
import { Validation } from '../../../../interfaces/common';
import {
  VALIDATION_FIELD_MAPPING,
  APP_ERROR_MESSAGES,
} from '../../../../utils/appConstant';
import { parseDateToLocal } from '../../../../utils/methods';

export const validateAddEditForm = (formData: AddEdit, fieldToValidate?: string) => {
  const validations: Validation = { validate: true, fields: [] };

  // Helper to add validation error
  const addError = (field: string, message: string) => {
    validations.validate = false;
    validations.fields.push({ field, message });
  };

  // Name
  if (!formData.name?.trim()) {
    addError(
        VALIDATION_FIELD_MAPPING.name,
        APP_ERROR_MESSAGES.properties.addEdit.blankPropertyName
    );
  }



  // Category
  if (!formData.category_id) {
       addError(
        VALIDATION_FIELD_MAPPING.categoryId,
        APP_ERROR_MESSAGES.common.dropdown.notSelected
    );
  }

  // Construction Status
  if (!formData.construction_status) {
       addError(
        VALIDATION_FIELD_MAPPING.construction_status,
        APP_ERROR_MESSAGES.common.dropdown.notSelected
    );
  }

  // Approval Status
  if (!formData.approval_status) {
       addError(
        VALIDATION_FIELD_MAPPING.approval_status,
        APP_ERROR_MESSAGES.properties.addEdit.blankApprovalStatus
    );
  }

  // Launch Date vs Possession Date
  if (formData.launch_date && formData.possession_date) {
      const launch = parseDateToLocal(formData.launch_date);
      const possession = parseDateToLocal(formData.possession_date);
      if (launch && possession && launch > possession) {
          addError(
              VALIDATION_FIELD_MAPPING.launch_date,
              APP_ERROR_MESSAGES.properties.addEdit.invalidLaunchDate
          );
      }
  }
  
  // Developers
  if (!formData.developer_property || formData.developer_property.length === 0) {
      addError(
        VALIDATION_FIELD_MAPPING.developer_property,
        APP_ERROR_MESSAGES.common.dropdown.notSelected
      );
  }


  // Address
  if (!formData.address_line_1?.trim()) {
    addError(
        VALIDATION_FIELD_MAPPING.addressLine1,
        APP_ERROR_MESSAGES.properties.addEdit.blankAddress
    );
  }

  if (!formData.country_id) {
    addError(
        VALIDATION_FIELD_MAPPING.countryId,
        APP_ERROR_MESSAGES.properties.addEdit.blankCountry
    );
  }
  if (!formData.state_id) {
    addError(
        VALIDATION_FIELD_MAPPING.stateId,
        APP_ERROR_MESSAGES.properties.addEdit.blankState
    );
  }
  if (!formData.city_id) {
    addError(
        VALIDATION_FIELD_MAPPING.cityId,
        APP_ERROR_MESSAGES.properties.addEdit.blankCity
    );
  }
  if (!formData.area_id) {
    addError(
        VALIDATION_FIELD_MAPPING.area_id,
        APP_ERROR_MESSAGES.properties.addEdit.blankArea
    );
  }
  if (!formData.area || formData.area.length === 0) {
    addError(
        VALIDATION_FIELD_MAPPING.area,
        APP_ERROR_MESSAGES.properties.addEdit.blankNearbyArea
    );
  }
  // Pincode
  if (!formData.pincode?.trim()) {
      addError(
        VALIDATION_FIELD_MAPPING.pincode,
        APP_ERROR_MESSAGES.properties.addEdit.blankPostcode
    );
  }




  // Lat/Long
  if (formData.latitude && !/^-?\d+(\.\d+)?$/.test(String(formData.latitude))) {
      addError(
          VALIDATION_FIELD_MAPPING.latitude,
          APP_ERROR_MESSAGES.properties.addEdit.invalidLatitude
      );
  }
  if (formData.longitude && !/^-?\d+(\.\d+)?$/.test(String(formData.longitude))) {
       addError(
          VALIDATION_FIELD_MAPPING.longitude,
          APP_ERROR_MESSAGES.properties.addEdit.invalidLongitude
      );
  }

  // Launch Date vs Possession Date
  if (formData.launch_date && formData.possession_date) {
      const launch = parseDateToLocal(formData.launch_date);
      const possession = parseDateToLocal(formData.possession_date);
      if (launch && possession && launch > possession) {
          addError(
              VALIDATION_FIELD_MAPPING.launch_date,
              APP_ERROR_MESSAGES.properties.addEdit.invalidLaunchDate
          );
      }
  }

  // Helper to remove HTML tags
  const stripHtml = (html: string) => {
    return html ? html.replace(/<[^>]*>?/gm, '').trim() : '';
  };

  // Description
  if (!stripHtml(formData.description || '')) {
       addError(
        VALIDATION_FIELD_MAPPING.description,
        APP_ERROR_MESSAGES.properties.addEdit.blankDescription
    );
  }

  // WhatsApp Description
   if (!stripHtml(formData.whatsapp_description || '')) {
       addError(
        'whatsapp_description',
        APP_ERROR_MESSAGES.properties.addEdit.blankWhatsAppDescription
    );
  }
  
  // Developers
  if (!formData.developer_property || formData.developer_property.length === 0) {
      addError(
        VALIDATION_FIELD_MAPPING.developer_property,
        APP_ERROR_MESSAGES.common.dropdown.notSelected
      );
  }

  // Contact Details
  if (!formData.property_contact_details || formData.property_contact_details.length === 0) {
      addError(
          'property_contact_details',
          APP_ERROR_MESSAGES.properties.addEdit.blankContactDetails
      )
  } else {
      // Validate each contact record
      formData.property_contact_details.forEach((contact, index) => {

          // Required checks
          if (!contact.contact_person?.trim()) {
               addError(
                  `contact_person-${index}`,
                  APP_ERROR_MESSAGES.properties.addEdit.blankContactPerson
              );
          }
          if (!contact.contact_number?.trim()) {
               addError(
                  `contact_number-${index}`,
                  APP_ERROR_MESSAGES.properties.addEdit.blankContactNumber
              );
          } else if (contact.contact_number && contact.contact_number.replace(/\s/g, '').length !== 10) { 
               addError(
                  `contact_number-${index}`,
                  APP_ERROR_MESSAGES.properties.addEdit.invalidPhoneNumber
              );
          }
          // Email is now optional, but validate format if present
          if (contact.email?.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email)) {
              addError(
                  `email-${index}`,
                  APP_ERROR_MESSAGES.common.invalidEmail
              );
          }

      });

      // Check if at least one contact is primary
      const hasPrimary = formData.property_contact_details.some(contact => contact.is_primary);
      if (!hasPrimary) {
           addError(
              'property_contact_details',
              APP_ERROR_MESSAGES.properties.addEdit.contactPrimaryRequired
          );
      }
  }

  // Inventory Details
  if (!formData.property_unit_types || formData.property_unit_types.length === 0) {
      addError(
          'property_unit_types',
          APP_ERROR_MESSAGES.properties.addEdit.blankInventoryDetails
      )
  } else {
      formData.property_unit_types.forEach((unit, index) => {
          if (!unit.property_type_id) {
               addError(
                  `property_type_id-${index}`,
                  APP_ERROR_MESSAGES.properties.addEdit.blankPropertyType
              );
          }
          if (!unit.measurement) {
               addError(
                  `measurement-${index}`,
                  APP_ERROR_MESSAGES.properties.addEdit.measurementRequired || "Measurement is required"
              );
          }
          if (!unit.rera_area) {
               addError(
                  `rera_area-${index}`,
                  APP_ERROR_MESSAGES.properties.addEdit.blankReraArea
              );
          } else if (!/^\d{0,8}(\.\d{0,2})?$/.test(String(unit.rera_area))) {
               addError(
                  `rera_area-${index}`,
                  APP_ERROR_MESSAGES.properties.addEdit.invalidReraArea
              );
          }
           // total_units is now optional
      });
  }
  
  // Documents Validation
  if (formData.documents && formData.documents.length > 0) {
      formData.documents.forEach((doc: any, index: number) => {
          // Check if document needs a type (usually all documents need a type)
          // For existing documents, doc_type should be there.
          // For new documents, it must be selected.
          if (!doc.doc_type) {
               addError(
                  `documents-${index}-doc_type`,
                   APP_ERROR_MESSAGES.common.dropdown.notSelected
              );
          }
      });
  }

  return validations;
};
